import { WidgetSelector as WidgetSelectorLut } from 'legacy/lut/components/widgets/WidgetSelector'

import { lazyRenderWidgetByLoader, projectLoaders } from 'core-components/helpers/lazyLoad'
import { IWidgetSelector } from 'core-components/sitebuilder/models/IWidgetSelector'

projectLoaders['hpscoutso/'] = (name: string) => {
  const layoutName = name.split('/').at(-1)
  return import(`hpscoutso/components/layout/${layoutName}.tsx`)
}

export const WidgetSelector = (props: IWidgetSelector) => {
  const WidgetSelectorMembershipSimulator = props.lazyWidgets?.HMSWidgetSelector
  const WidgetSelectorCheckEngine = props.lazyWidgets?.CheckEngineWidgetSelector
  const WidgetSelectorAmplifyImpact = props.lazyWidgets?.AmplifyImpactWidgetSelector
  const KbaseWidgetSelector = props.lazyWidgets?.KbaseWidgetSelector
  const DocflowWidgetSelector = props.lazyWidgets?.DocflowWidgetSelector

  if (props.viewModel === 'translations-admin-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/translationCatalog'),
      props: props.props,
    })
  }

  if (props.viewModel === 'flags-admin-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/flagManagement'),
      props: props.props,
    })
  }

  if (props.viewModel === 'country-province-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/CountryProvince'),
      props: props.props,
    })
  }

  if (props.viewModel === 'dynamic-filter') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/hpscoutso/components/widgets/public/dynamicFilter/DynamicFilter'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'activity-calendar') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/hpscoutso/components/widgets/public/activityCalendar/widgets/activityCalendar/ActivityCalendar'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'block-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/hpscoutso/components/widgets/public/activityCalendar/widgets/BlockPanel/BlockPanel'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'filter-grid') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/hpscoutso/components/widgets/public/filter/Filters'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'save-manager') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/hpscoutso/components/widgets/public/saveManager/SaveManager'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'adaptive-card') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/hpscoutso/components/widgets/public/adaptiveCard/AdaptiveCardMain'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'cs-user-mamagement-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/hpscoutso/components/widgets/public/csUserManagement/UserManagement'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'cs-header-navigate') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/hpscoutso/components/widgets/public/csHeaderNavigate/CsHeaderNavigate'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-device-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/devicesInfo/partnerDevicesInfo/PartnerDevicesInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-market-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/marketInfo/partnerMarketInfo/PartnerMarketInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'programs-management-admin-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/ProgramsManagementAdmin'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partnersearchv2-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/searchForm/SearchForm'),
      props: { ...props.props, isCompletenessVisible: true },
    })
  }

  if (props.viewModel === 'partner-search-results') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/searchResult/SearchResults'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-base-metrics-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/devicesInfo/partnerBaseMetrics/PartnerBaseMetrics'),
      props: props.props,
    })
  }

  if (props.viewModel === 'top-vendor-brands-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/devicesInfo/topVendorBrands/TopVendorBrands'),
      props: props.props,
    })
  }

  if (props.viewModel === 'vertical-market-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/widgets/marketInfo/partnerVerticalMarket/PartnerVerticalMarket'),
      props: props.props,
    })
  }

  if (props.viewModel === 'hp-solutions-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/PartnerSolutions'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-contact-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/PartnerContactInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'сompensation-scheme-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/Compensation'),
      props: props.props,
    })
  }

  if (props.viewModel === 'actions-plan-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/ActionsPlan'),
      props: props.props,
    })
  }

  if (props.viewModel === 'commitment-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/CommitmentWrapper'),
      props: props.props,
    })
  }

  if (props.viewModel === 'acknowledgment-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/acknowledgment'),
      props: props.props,
    })
  }

  if (props.viewModel === 'completeness-indicator-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/PartnerCompletenessWrapper'),
      props: props.props,
    })
  }

  if (props.viewModel === 'f-years-selector') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/fYearSelector/FYearsSelector'),
      props: props.props,
    })
  }

  if (props.viewModel === 'completeness-report-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/reports/Reports'),
      props: props.props,
      loadMeta: true,
    })
  }

  if (props.viewModel === 'parnter-financial-offering-leasing-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/marketInfo/partnerLeasing/PartnerLeasing'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-historical-results-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/PartnerHistoricalResults'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-daas-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/DaasSummary'),
      props: props.props,
    })
  }

  if (props.viewModel === 'hp-contacts-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/hpContactsTable/HPContactsTable'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-country-top-partner-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/TopPartnerSummary'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-master-dealer-table-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/PartnerMasterDealerTable'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-mps-top-partner-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/historicalResults/mps/MPSSummary'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-country-manager-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/backOffice/countryManagerSummary/CountryManagerSummary'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'catalyst-iframe') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/hpscoutso/components/widgets/public/CatalystIFrame'),
      props: props.props,
    })
  }

  if (props.viewModel === 'c&g-user-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/userList/UserList'),
      props: props.props,
    })
  }

  if (props.viewModel === 'c&g-user-details') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/userDetails/UserDetails'),
      props: props.props,
    })
  }

  if (props.viewModel === 'cs-hub-management') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/hpscoutso/components/widgets/public/csHubManagement/HubManagement'),
      props: props.props,
    })
  }

  if (props.viewModel === 'apl-documents-upload-form') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/hpscoutso/components/pages/aplUploadForm/APLUploadForm'),
      props: props.props,
    })
  }

  if (props.viewModel === 'cng-page-promotions') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/promotions'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-landing') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/partnerLanding/PartnerLanding'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  return (
    (WidgetSelectorMembershipSimulator && WidgetSelectorMembershipSimulator(props)) ||
    (WidgetSelectorCheckEngine && WidgetSelectorCheckEngine(props)) ||
    (WidgetSelectorAmplifyImpact && WidgetSelectorAmplifyImpact(props)) ||
    (KbaseWidgetSelector && KbaseWidgetSelector(props)) ||
    (DocflowWidgetSelector && DocflowWidgetSelector(props)) ||
    WidgetSelectorLut(props)
  )
}
